$(document)
  .on('init:paymentMethodSelector.nearme', () => {
    const els = $('[data-payment-methods]');
    if (els.size()) {
      require.ensure('../payment_methods/payment_method_selector', require => {
        let PaymentMethodSelector = require('../payment_methods/payment_method_selector');
        els.each((index, el) => new PaymentMethodSelector(el));
      });
    }
  })
  .trigger('init:paymentMethodSelector.nearme');



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/payment_method_selector.initializer.js